export const DEFAULT_MAP_CENTER = { lat: 37.5665, lng: 126.978 };
export const HOTPLE_DEFAULT_CENTER = {
  lat: 37.54666563187861,
  lng: 126.98225129089356,
};
export const DEFAULT_MAP_ZOOM = 12;
export const DEFAULT_PLACES_MAP_ZOOM = 15;

export const MAPLIBRE_PM_TILES_URL =
  process.env.NEXT_PUBLIC_MAPLIBRE_PM_TILES_URL ||
  "https://maps-r2.hotple.com/basemaps/korea.pmtiles";

export const MAPLIBRE_WORKER_URL =
  "/vendor/maplibre/maplibre-gl-csp-worker.js";

export const normalizeMapColor = (value, fallback) => {
  const rawColor = typeof value === "string" ? value.trim() : "";
  if (!rawColor) return fallback;

  const color = rawColor.startsWith("#") ? rawColor : `#${rawColor}`;
  return /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(
    color
  )
    ? color
    : fallback;
};

export const isValidMapPosition = (position) =>
  position &&
  typeof position.lat === "number" &&
  typeof position.lng === "number" &&
  Number.isFinite(position.lat) &&
  Number.isFinite(position.lng) &&
  position.lat !== 0 &&
  position.lng !== 0;

export const getMarkerColorFromMarker = (marker, fallback = "#ff2e4d") =>
  normalizeMapColor(marker?.properties?.color || marker?.color, fallback);
